import { gql } from '@apollo/client';
/**
 * @const GetDealConnectorRefQuery
 * @since 1.0.0
 */
export const GetDealConnectorRefQuery = gql `
  query GetDealConnectorRef($input: GetDealConnectorRefInput!) {
    getDealConnectorRef(input: $input) {
      ref
      type
    }
  }
`;
